import axiosPrivate from "@services/axiosPrivate"
import { ADD_NEW_PATIENT } from "src/constants"

export const addNewPatient = (data) => {
  // console.log("hello")
  return axiosPrivate.post(ADD_NEW_PATIENT, data, {
    withCredentials: true,
  })
}
